import { render, staticRenderFns } from "./NavigationGroup.vue?vue&type=template&id=22fbceac&scoped=true"
import script from "./NavigationGroup.vue?vue&type=script&lang=js"
export * from "./NavigationGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fbceac",
  null
  
)

export default component.exports